import React, { useState } from 'react';

// Show/hide toggle for password fields — 👁 while hidden (click to reveal), 🙈
// (see-no-evil monkey) once revealed (click to hide again). Matches the pattern
// used across the PrimeClean product family's other apps.
const PasswordInput = ({ className = 'form-control', style, value, onChange, placeholder, required, autoComplete, autoFocus, disabled, id, name }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: 'relative', ...style }}>
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '2.4rem', width: '100%' }}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        disabled={disabled}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        title={visible ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute', right: '0.6rem', top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', fontSize: 'var(--fs-lg)',
          lineHeight: 1, padding: '0.15rem', display: 'flex', alignItems: 'center',
        }}
      >
        {visible ? '🙈' : '👁'}
      </button>
    </div>
  );
};

export default PasswordInput;
